import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=dcba2d94&scoped=true"
import script from "./Book.vue?vue&type=script&lang=js"
export * from "./Book.vue?vue&type=script&lang=js"
import style0 from "./Book.vue?vue&type=style&index=0&id=dcba2d94&prod&scoped=true&lang=css"
import style1 from "./Book.vue?vue&type=style&index=1&id=dcba2d94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcba2d94",
  null
  
)

export default component.exports